import Vue from "vue"
// how use v-my-loading="{ text: '',icon :'el-icon-loading', background:'rgba(0, 0, 0, 0.8)' }"
Vue.directive('my-loading', {
	inserted(el, binding, vNode){

	},
	bind(el, binding, vNode){

			const t = binding.value;

			if(t && t.text && t.text.trim() !=''){
				el.setAttribute('element-loading-text',t.text);
			}

			if(t && t.icon && t.icon.trim() !=''){
				el.setAttribute('element-loading-spinner',t.icon);
			}else{
				el.setAttribute('element-loading-spinner','el-icon-loading');
			}
			if(t && t.background && t.background.trim() !=''){
				el.setAttribute('element-loading-background',t.background);
			}

			//el.setAttribute('element-loading-custom-class','el-icon-loading');



	},
	update(el, binding, vNode){

	},
});